<template>
  <div
    id="fee_deposit"
    v-loading.fullscreen.lock="pageLoading"
  >
    <div class="main">
      <div class="rule">
        <div class="title">
          入帳規則
        </div>
        <div class="itemWrap">
          <div v-if="feeContent[feeType]" class="item">
            1.{{ feeTypeName }}{{ feeContent[feeType].description }}
          </div>
          <div v-if="feeType === 'management' || feeType === 'default-management'" class="item">
            <p v-for="(item) in feeContent[feeType].details" :key="item" class="contentText">
              ※{{ item }}
            </p>
          </div>
          <div v-if="feeType === 'other-management'" class="item contentText">
            <p>舉例說明：</p>
            <p v-for="(example, index) in feeContent[feeType].examples" :key="index">
              {{ example }}
            </p>
          </div>
          <br>
          <p class="item contentText">
            ※備註：住戶於超商繳費時帳務日期的認列不完全等於住戶繳費交易日期，會因繳費當下時間代收通路四大超商是否已完成結帳，若完成結帳就會被認列當下一個營業日的帳務日期，各繳費方式依照2022/9/1 23:00 完成交易時間，舉例說明如下：
          </p>
          <p class="item contentText">
            ※統一/萊爾富：結帳時間為15:00 ，交易時間已超過結帳時間，繳費交易日期9/1，帳務日期是9/2
          </p>
          <p class="item contentText">
            ※全家：結帳時間為23:59 ，交易時間未超過結帳時間，繳費交易日期9/1，帳務日期是9/1
          </p>
          <p class="item contentText">
            ※OK：結帳時間為7:00 ，交易時間已超過結帳時間，繳費交易日期9/1，帳務日期是9/2
          </p>
          <br>
          <div class="item">
            2.匯款日遇例假日、特定假日或天災地變等不可抗力事件則得順延至次一個銀行營業日辦理，屆時以系統公告為主。
          </div>
          <br>
          <div class="item">
            3.社區款項如因代收通路延遲撥款或漏帳等不可抗力之因素導致無法如期撥款，智生活不負損害賠償責任，惟應以網頁公告、電話或email通知銀行及代收通路，並協商三方因應處理方式後，另行通知補撥款日。
          </div>
        </div>
      </div>
      <div class="rule">
        <div class="title">
          {{ $t('Fee.InvoiceDescription') }}
        </div>
        <div class="itemWrap">
          <div class="item">
            1.{{ $t('Fee.InvoiceDescriptionContent[0]') }}
          </div>
          <div class="item">
            2.{{ $t('Fee.InvoiceDescriptionContent[1]') }}
          </div>
          <div class="item">
            <a class="link" target="_blank" href="https://www.einvoice.nat.gov.tw/accounts/login/b?login">{{ $t('Fee.InvoiceDescriptionContent[2]') }}</a>
          </div>
          <div class="item">
            {{ $t('Fee.InvoiceDescriptionContent[3]') }}
          </div>
        </div>
      </div>
      <filter-frame
        :filter-form="depositFilter"
        @search="getList"
        @clear="getListDefault()"
      />
      <div class="title_bar">
        <div class="left" />
        <div class="right">
          <span>搜尋結果共計{{ depositData.length }}筆</span>
        </div>
      </div>
      <list-frame
        v-loading="loadingList"
        :list-form="depositList"
        :list-data="depositData"
      >
        <el-table-column
          slot="TotalEntryAmount"
          class-name="total-entry-amount"
          width="150"
          :label="$t('Fee.TotalEntryAmount')"
          align="right"
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.RemittanceFee && scope.row.RemittanceFee > 0"
              :content="$t('Fee.RemittanceFeeMemo', {
                currentPeriodAmount: scope.row.CurrentPeriodAmount,
                remittanceFee: scope.row.RemittanceFee,
                totalEntryAmount: scope.row.TotalEntryAmount
              })"
              placement="bottom"
            >
              <i class="icon-info info" />
            </el-tooltip>
            {{ scope.row.TotalEntryAmount }}
          </template>
        </el-table-column>
        <el-table-column
          slot="Operation"
          class-name="operation"
          width="130"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              plain
              @click="handleDownloadExcel(scope.row)"
            >
              下載
            </el-button>
          </template>
        </el-table-column>
      </list-frame>
    </div>
  </div>
</template>
<script>
import filterFrame from '@/components/FilterFrame'
import listFrame from '@/components/ListFrame'
const LastThreeMonthRange = [dayjs().add(-3, 'month').format('YYYY-MM-DD'), dayjs().add(1, 'month').format('YYYY-MM-DD')]
export default {
  components: {
    'filter-frame': filterFrame,
    'list-frame': listFrame
  },
  data () {
    const defaultFeeContent = {
      description: '代收款項將依照住戶繳費時間，代收通路（銀行、超商）所認列的帳務日期進行撥款，撥款週期規則如下：',
      details: [
        '帳務日期每月1-10號將於當月19號撥款至社區帳戶',
        '帳務日期每月11-20號將於當月29號撥款至社區帳戶',
        '帳務日期每月21-31號將於次月9號撥款至社區帳戶'
      ]
    }

    return {
      pageLoading: false,
      loadingList: false,
      filterCondition: null,
      depositFilter: [
        {
          label: '預計入帳',
          name: 'ExpectEntryDate',
          type: 'date',
          value: LastThreeMonthRange,
          pickerOptions: ['currentMonth', 'currentYear']
        },
        {
          label: '實際入帳',
          name: 'ActualEntryDate',
          type: 'date',
          pickerOptions: ['currentMonth', 'currentYear']
        }
      ],
      depositList: [
        {
          prop: 'EntryDuration',
          label: '入帳週期',
          sortable: true
        },
        {
          prop: 'ExpectEntryDate',
          label: '預計入帳日',
          width: '150',
          sortable: true
        },
        {
          prop: 'ActualEntryDate',
          label: '實際入帳日',
          width: '150',
          sortable: true
        },
        {
          prop: 'TotalPayAmount',
          label: '繳費總額',
          width: '150',
          align: 'right'
        },
        {
          prop: 'EntryCount',
          label: '繳費筆數',
          width: '120',
          align: 'right'
        },
        {
          prop: 'TotalHandlingFee',
          label: '代收手續費',
          width: '150',
          align: 'right'
        },
        {
          prop: 'TotalDataServiceFee',
          label: '資料服務費',
          width: '150',
          align: 'right'
        },
        {
          prop: 'TransferHandlingFee',
          label: '匯款手續費',
          width: '100',
          align: 'right'
        },
        {
          slot: 'TotalEntryAmount'
        },
        {
          slot: 'Operation'
        }
      ],
      depositData: [],
      feeType: 'management',
      feeContent: {
        'default-management': defaultFeeContent,
        management: defaultFeeContent,
        'other-management': {
          description: '代收款項將依照住戶繳費時間，代收通路（銀行、超商）所認列的帳務日期進行撥款，帳務日期為前一月11日～當月10日，將於當月19號撥款至社區帳戶。',
          examples: [
            '帳務日期為9／11～10／10之款項，將於10／19進行撥款。',
            '帳務日期為10／11～11／10之款項，將於11／19進行撥款。'
          ]
        }
      }
    }
  },
  computed: {
    feeTypeName () {
      switch (this.feeType) {
      case 'other-management':
        return ''
      case 'management':
        return '管理費'
      default:
        return '管理費'
      }
    }
  },
  mounted () {
    this.getListDefault()
    this.feeType = this.$route.params.type
  },
  methods: {
    getListDefault () {
      this.getList({
        ExpectEntryDate: LastThreeMonthRange
      })
    },
    getList (condition) { // 取得入帳列表
      console.log(condition)
      this.loadingList = true
      if (condition) {
        this.filterCondition = _cloneDeep(condition)
      }
      const requestData = this.filterCondition
        ? Object.assign(
          {},
          this.filterCondition.ExpectEntryDate && {
            'ExpectEntryDateFilter.StartDate': this.filterCondition.ExpectEntryDate[0],
            'ExpectEntryDateFilter.EndDate': this.filterCondition.ExpectEntryDate[1]
          },
          this.filterCondition.ActualEntryDate && {
            'ActualEntryDateFilter.StartDate': this.filterCondition.ActualEntryDate[0],
            'ActualEntryDateFilter.EndDate': this.filterCondition.ActualEntryDate[1]
          }
        )
        : null
      console.log(requestData)

      apiBillserviceKGI.Receipt.GetEntryReport(
        requestData
      ).then((res) => {
        console.log(res.data.ReceiptEntryReports)
        this.depositData = res.data.ReceiptEntryReports.map((e) => {
          e.ExpectEntryDate = this.$formatDate(e.ExpectEntryDate)
          e.ActualEntryDate = this.$formatDate(e.ActualEntryDate)
          e.EntryCycleStartDate = this.$formatDate(e.EntryCycleStartDate)
          e.EntryCycleEndDate = this.$formatDate(e.EntryCycleEndDate)
          e.EntryDuration = `${this.$formatDate(e.EntryCycleStartDate)}-${this.$formatDate(e.EntryCycleEndDate)}`
          e.TotalEntryAmount = e.TotalEntryAmount ? e.TotalEntryAmount.toLocaleString() : e.TotalEntryAmount
          e.TotalPayAmount = e.TotalPayAmount ? e.TotalPayAmount.toLocaleString() : e.TotalPayAmount
          e.TotalDataServiceFee = e.TotalDataServiceFee ? e.TotalDataServiceFee.toLocaleString() : e.TotalDataServiceFee || 0
          e.RemittanceFee = e.RemittanceFee ? e.RemittanceFee.toLocaleString() : 0
          e.CurrentPeriodAmount = e.CurrentPeriodAmount ? e.CurrentPeriodAmount.toLocaleString() : 0
          return e
        })
        this.loadingList = false
      }).catch((err) => {
        this.$message({
          message: '取得入帳報表失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
        this.loadingList = false
      })
    },
    handleDownloadExcel (rowData) { // 下載excel
      this.pageLoading = true
      const requestData = {
        ExpectEntryDate: rowData.ExpectEntryDate
      }
      const config = {
        responseType: 'blob' // important
      }
      apiBillserviceKGI.Receipt.GetEntryReportExport(
        requestData,
        config
      ).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        // link.setAttribute('download',`${row.BillBulkName}_${this.getNowDate()}.xlsx`) //or any other extension
        link.setAttribute('download', `${decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1].replace(/"/g, ''))}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.pageLoading = false
      }).catch((err) => {
        console.log(err)
        console.log(err.response)
        this.$message({
          message: '下載報表失敗，請稍後再試',
          type: 'warning'
        })
        this.pageLoading = false
      })
    }
  }
}
</script>
<style lang="sass" scoped>
::v-deep .total-entry-amount
  .cell
    display: flex
    justify-content: right
    align-items: center
    gap: 5px
#fee_deposit
  text-align: center
  .main
    min-width: 900px
    color: $mainFontColor
    .rule
      display: flex
      justify-content: space-between
      align-items: flex-start
      padding: 20px 15px 10px
      text-align: left
      .title
        font-weight: bold
        font-size: map-get($fontSize,small)
        margin-bottom: 10px
        flex-basis: 150px
      .itemWrap
        flex: 1
        .item
          line-height: 1.4
          &.contentText
            text-indent: 0.5em
          .link
            cursor: pointer
            color: $mainColor
            &:hover
              text-decoration: underline
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 20px 0
      .right
        span
          margin: 0 20px
          color: $mainFontColor
          vertical-align: middle
</style>
